import React, { useEffect, useState } from "react";
import RentalList from "../components/RentalList";
import CarRentalPricing from "../components/CarRentalPricing";
import { sanityClient } from "../lib/sanityClient";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CarRentalPage = () => {
  const { lang } = useParams();
  const { t, i18n } = useTranslation();

  const [rentals, setRentals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (lang) i18n.changeLanguage(lang);

    const fetchRentalData = async () => {
      try {
        const query = `*[_type == "carRental"]{
          _id, 
          vehicle->{title, brand, model, year, primaryImage}, 
          pricePerDay, 
          rentalTerms, 
          availability
        }`;

        const fetchedRentals = await sanityClient.fetch(query);
        setRentals(fetchedRentals);
      } catch (error) {
        console.error("Error fetching rental data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRentalData();
  }, [lang, i18n]);

  if (loading) {
    return <div className="text-center mt-8">{t("loading")}</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>{t("rental.title")}</title>
        <meta name="description" content={t("rental.description")} />
        <link rel="canonical" href='https://237mechanic.com/cm/en/car-rentals' />

      </Helmet>

      <div className="mt-8">
        <h2 className="text-3xl font-bold text-center mb-6">{t("rental.heading")}</h2>
        {rentals.length > 0 ? (
          <RentalList rentals={rentals} />
        ) : (
          <p className="text-center text-gray-500">{t("rental.notAvailable")}</p>
        )}
      </div>

      <CarRentalPricing />

      <p className="mt-6 text-gray-700">{t("rental.bottomText")}</p>
    </div>
  );
};

export default CarRentalPage;
